import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  userName: string | null;
}

const getInitialAuth = (): AuthState => {
  const token = sessionStorage.getItem('buyer_token');
  const storedUser = sessionStorage.getItem('buyer_user');
  let userName = null;
  if (storedUser) {
    try {
      const u = JSON.parse(storedUser);
      userName = u.name || u.firstName || u.email;
    } catch (e) {}
  }
  const valid = Boolean(token && token !== 'null' && token !== 'undefined' && token !== 'false');
  return {
    isAuthenticated: valid,
    token: valid ? token : null,
    userName: valid ? userName : null,
  };
};

const initialState: AuthState = getInitialAuth();

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (
      state,
      action: PayloadAction<{ token: string; userName: string }>
    ) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.userName = action.payload.userName;
      sessionStorage.setItem('buyer_token', action.payload.token);
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.userName = null;
      sessionStorage.removeItem('buyer_token');
      sessionStorage.removeItem('buyer_user');
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;

export default authSlice.reducer;